import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { environment } from "../../../environments/environment";
import { OutpassPrintDataModel, PrintUnitGroupModel, PrintProductModel, PrintItemModel, Modules, Responsibility, DocumentCode, ActiveDocumentVersionVm } from 'shared/models';
import { CompanyInfo } from "shared/models";
import { AuthService } from "shared/core";
import { DocumentService } from "shared/core";
import { sentByText } from "../components/outpass-sent-by-display";

@Component({
    selector: "app-outpasspackinglistprint",
    templateUrl: "./outpasspackinglistprint.component.html",
    styleUrls: ["./outpasspackinglistprint.component.css"],
    standalone: false
})
export class OutPassPackingListPrintComponent implements OnInit {
  ApiUrl = environment.Api_Url;
  OutpassId = 0;
  private route$: Subscription = new Subscription();
  count: number = 0;
  PrintAllowed: boolean = false;
  Company = {
    CompanyName: '',
    HeadOfficeAddress: '',
    FactoryAddress: ''
  };

  // Document version for IATF compliance
  ActiveDocumentVersion: ActiveDocumentVersionVm;

  // Print data from backend
  printData: OutpassPrintDataModel = new OutpassPrintDataModel();
  sentByDisplay: string = '';
  loading: boolean = false;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private documentService: DocumentService
  ) {
    this.count = 0;
  }

  ngOnInit() {
    this.route$ = this.route.params.subscribe((params: Params) => {
      this.OutpassId = params['id'];
    });
    this.Company.CompanyName = CompanyInfo.CompanyName;
    this.Company.HeadOfficeAddress = CompanyInfo.HeadOfficAddress;
    this.Company.FactoryAddress = CompanyInfo.FactoryAddress;
    this.GetOutPassPackingListData(this.OutpassId);
    this.GetDocumentVersion();
  }

  GetDocumentVersion() {
    this.documentService.getActiveVersionByCode(DocumentCode.OutPassPackingList)
      .subscribe(res => {
        this.ActiveDocumentVersion = res;
      });
  }

  ngOnDestroy() {
    this.route$.unsubscribe();
  }

  // Get packing list data from backend
  GetOutPassPackingListData(outpassId: number) {
    this.loading = true;
    let url = this.ApiUrl + 'outpass/getoutpassprintdata?outpassid=' + outpassId;
    this.http.get<OutpassPrintDataModel>(url).subscribe(
      (res) => {
        this.printData = res;
        this.sentByDisplay = sentByText(res.OutpassDetails);
        this.PrintAllowed = ['Approved', 'Approval Pending', 'Gate Out Completed'].includes(this.printData.OutpassDetails.Status);
        this.loading = false;

        // Auto-print after data loads
        setTimeout(() => {
          window.print();
          window.onafterprint = () => {
            window.close();
          };
        }, 100);
      },
      (error) => {
        this.loading = false;
        this.count++;
        if (this.count < 2) {
          this.GetOutPassPackingListData(outpassId);
        }
        console.error('Error loading OutPass packing list data:', error);
      }
    );
  }

  // Helper method to get all barcode items with serial numbers
  getAllBarcodeItems(): PrintItemModel[] {
    const barcodeItems: PrintItemModel[] = [];

    this.printData.UnitGroups.forEach(unitGroup => {
      unitGroup.Products.forEach(product => {
        product.Items.forEach(item => {
          if (item.EntryType === 'Barcode' && item.SerialNumbers.length > 0) {
            // Create individual entries for each serial number
            item.SerialNumbers.forEach((serialNo, index) => {
              barcodeItems.push({
                ...item,
                SerialNumbers: [serialNo], // Single serial number per item
                PackagingUnits: item.PackagingUnits.length > index ? [item.PackagingUnits[index]] : [],
                Quantity: item.Quantity / item.SerialNumbers.length, // Distribute quantity
                TotalAmount: item.TotalAmount / item.SerialNumbers.length // Distribute amount
              });
            });
          }
        });
      });
    });

    return barcodeItems;
  }

  // Helper method to get packaging summary
  getPackagingSummary(): string {
    return this.printData.Summary?.OverallPackagingBreakdown || '';
  }

  // Helper method to check if OutPass has barcode items
  hasBarcodeItems(): boolean {
    return this.printData.Summary?.TotalBarcodeItems > 0;
  }

  // Helper method to get short code for barcode items
  getShortCode(item: PrintItemModel): string {
    if (item.EntryType === 'Barcode') {
      return (item as any).ShortCode || 'N/A';
    }
    return 'N/A';
  }
}
